const tables = {
    init() {
        $(document).ready(() => {
            $('table.wp-block-table').each((i, e) => {
                $(e).wrap('<div class="table-wrap"></div>');
            });
        });
    },
};

export default tables;
